import PropTypes from 'prop-types'
import React, { memo, useCallback } from 'react'
import TextField from '../../../../../../components/TextField'

function PolicyTextField({ id, onChange, values = null, errors = [], placeholder = '' }) {
  const handleChange = useCallback(
    (event) => {
      const nextValue = event?.target?.value
      onChange(nextValue === '' ? null : nextValue)
    },
    [onChange],
  )

  return (
    <TextField
      id={id}
      value={values ?? ''}
      onChange={handleChange}
      errors={errors}
      placeholder={placeholder}
      disablePasswordManager
      containerClassName="mb-0"
    />
  )
}

PolicyTextField.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
  placeholder: PropTypes.string,
}

export default memo(PolicyTextField)
